__turbopack_context__.v({
  "button-animation": "styles-module__fiVOMW__button-animation",
});
